import { assignInlineVars } from '@vanilla-extract/dynamic'
import { backgroundImage, showSidebarBlur } from './SidebarContent.css'

export const getJumbotronStyleObject = (
  sidebarImage: string | undefined,
  hideSidebarContent = false
) => {
  if (!sidebarImage) {
    return {}
  }

  const styleObject = {
    ...assignInlineVars({
      [backgroundImage]: `url(${sidebarImage})`,
      [showSidebarBlur]: hideSidebarContent ? 'none' : 'block',
    }),
  }

  return styleObject
}
